<style  lang="less" rel="stylesheet/less" scoped>
.playerenter {
  position: fixed;
  z-index: 30;
  top: 0;
  width: 100%;
  height: 100%;
  .playerenter_bg {
    width: 100%;
    height: 100%;
    opacity: 0.4;
  }
  .playerenter_cont{
    width: 445px;
    height: 277px;
    position: absolute;
		left: 50%;
    top: 50%;
    margin-top: -200px;
    margin-left: -139px;
    background: url(../../../assets/img/video/player_enter_bg.png) no-repeat;
    background-size:100% 100%; 
    p{
      font-size: 24px;
      color: #003057;
      text-align: left;
      padding-left: 61px;
      &:first-child{
        padding-top:62px;
      }
    }
}
  a{
    margin: 22px 0 0 61px;
    width: 160px;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
		background: #007A9C;
		color: #FFFFFF;
		border-radius: 5px;
    text-decoration: none;
    float: left;
	}
	a:hover{
		background: #005a70;
	}
}
</style>
<template>
  <div class="playerenter">
    <div class="playerenter_bg" :style="{background:videoBg}"></div>
    <div class="playerenter_cont">
      <p>点击按钮，</p>
      <p>就可以继续上课啦！</p>
      <a href="javascript:;;" @click="firstPlayVideo">继续上课</a>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
  computed: {
    ...mapState(["videoBg"])
  },
  methods: {
    firstPlayVideo() {
      this.$emit("firstPlayVideo");
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/bussiness/video/playerenter.vue